import {createAction, props} from '@ngrx/store';

export const experimentEvent = createAction(
  '[Google Optimize] Experiment callback was called',
  props<{ payload: { name: string; value: string } }>()
);
